<div class="flex flex-col w-full h-full bg-white md:rounded-2xl p-2 pl-0 md:shadow-fm">
    <fm-calendar class="h-full" />
</div>
